import { Pipe, PipeTransform } from '@angular/core';
import { InstallationCheckedPluginService } from './checked.service';
@Pipe({
    name: 'checkedstatus',
    standalone: false
})
export class CheckedStatusPipe implements PipeTransform {
  public statuses: any[];
  constructor(private service: InstallationCheckedPluginService) {
    this.statuses = this.service.getStatuses();
  }
  transform(id: string): any {
    return this.service.getValue(parseInt(id), this.statuses);
  }
}
